import { Box } from "@mui/system";
import React, { useState } from "react";
import FloatingContactMe from "../Profile Components/ChatBot/FloatingContactMe";

const useChatBot = (commesFrom, pic, logo, name, urlId, botOwner) => {
  const [chatOpen, setChatOpen] = useState(false);
  return (
    <Box>
      <FloatingContactMe
        commesFrom={commesFrom}
        pic={pic}
        logo={logo}
        name={name}
        urlId={urlId}
        chatOpen={chatOpen}
        setChatOpen={setChatOpen}
        botOwner={botOwner}
      />
    </Box>
  );
};

export default useChatBot;
